import { Box, Typography } from "@mui/material";
import React from "react";
import "./LoadingScreen.css";

const LoadingScreen = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        background:
          "linear-gradient(180deg, rgba(153,204,237,0.25), rgba(255,255,255,1))",
      }}
    >
      {/* LOGO / LOADER */}
      <div className="loader-rhombus">
        <span />
        <span />
        <span />
        <span />
      </div>

      {/* TEXT */}
      <Typography
        variant="subtitle1"
        sx={{
          color: "#0f7ca4",
          fontWeight: 600,
          letterSpacing: "0.05em",
          animation: "fadePulse 1.6s ease-in-out infinite",
        }}
      >
        Loading Den Den Claw…
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
